import type {
  TopupRequestDetail,
  TopupRequestsListResult,
} from "@/modules/wallet/domain/repo/topup-requests";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { TopupRequestDetail, TopupRequestsListResult };
export type TopupRequestItem = TopupRequestsListResult["data"][number];

export type TopupStats = {
  volume24h: number;
  oldestRequestAt: string | null;
  approvalRate: number;
};

export const topupApi = {
  async getStats(): Promise<TopupStats> {
    return fetcher.get<TopupStats>(`${config.apiUrl}/topup/stats`);
  },

  async list(query: OffsetPageQueryDTO): Promise<TopupRequestsListResult> {
    const url = new URL(`${config.apiUrl}/topup`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<TopupRequestsListResult>(url.toString());
  },

  async getDetail(id: string): Promise<TopupRequestDetail> {
    return fetcher.get<TopupRequestDetail>(`${config.apiUrl}/topup/${id}`);
  },

  async approve(id: string): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/topup/${id}/approve`,
    );
  },

  async reject(id: string, reason?: string): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/topup/${id}/reject`,
      { reason },
    );
  },
};
